import React from 'react'
import { DisplayHelpBlock } from './DisplayHelpBlock'

export type HelpBlockLayoutProps = { touched?: boolean; error?: string; help?: string }
export const HelpBlockLayout = ({ touched, error, help }: HelpBlockLayoutProps) => {
  let value = help ?? ''
  if (touched && error) value = error ?? ''
  return <DisplayHelpBlock value={value} />
}
